<template>
  <div>
    <ReportsCommissionsCustomer v-if="hasContractor" />
    <ReportsCommissionsPartner v-if="hasPartner" />
  </div>
</template>

<script>

import ReportsCommissionsCustomer from '@/views/ReportsCommissions/ReportsCommissionsCustomer.vue';
import ReportsCommissionsPartner from '@/views/ReportsCommissions/ReportsCommissionsPartner.vue';
import { mapState } from 'vuex';

export default {
  name: 'ReportsCommissions',
  components: {
    ReportsCommissionsCustomer,
    ReportsCommissionsPartner,
  },
  computed: {
    ...mapState('user', {
      hasContractor: (state) => state.contractor !== null,
      hasPartner: (state) => state.partnerId !== null,
    }),
  },
};
</script>
